/* =========================================================
   TIMESHOPEE · MOBILE FIRST helpers
   1. Measures the REAL fixed bottom menu bar -> --nv-bar-h
   2. Sticky "Add to cart" bar on product pages (phones only)
      - always sits flush ABOVE the bottom menu bar
      - shows only after the main Add to Cart button is scrolled away
      - steps aside for: keyboard, cart drawer, menus/popups, sold out,
        landscape phones and desktop
   ========================================================= */
(function () {
  if (window.__nvMobile) return;
  window.__nvMobile = true;

  var root = document.documentElement;
  var mq = window.matchMedia('(max-width: 749px)');
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  /* ---------------------------------------------------------
     1. bottom bar height
     Only the bar itself counts. The bar's block also renders a full-screen
     overlay + a slide-up menu drawer (both position:fixed, class starts with
     "ai-mobile-bottom-bar-"); those must NEVER be measured, otherwise the
     "bar" looks as tall as the whole screen.
  --------------------------------------------------------- */
  var barEl = null;
  var barRO = null;
  var ROOT_CLASS = /^ai-mobile-(bottom-bar|nav)-[a-z0-9]+$/;

  function findBar() {
    var list = document.querySelectorAll('[class*="ai-mobile-bottom-bar-"], [class*="ai-mobile-nav-"]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var isRoot = false;
      for (var j = 0; j < el.classList.length; j++) {
        if (ROOT_CLASS.test(el.classList[j])) { isRoot = true; break; }
      }
      if (!isRoot) continue;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = el.getBoundingClientRect();
      if (r.height <= 0 || r.height > window.innerHeight * 0.4) continue; // not a slim bar
      if (Math.abs(r.bottom - window.innerHeight) > 3) continue;           // not stuck to the bottom
      return el;
    }
    return null;
  }

  function measureBar() {
    var el = mq.matches ? findBar() : null;
    if (el !== barEl) {
      if (barRO) barRO.disconnect();
      if (barEl) barEl.classList.remove('nv-bottom-bar');
      barEl = el;
      if (barEl) {
        barEl.classList.add('nv-bottom-bar'); // gets the iPhone home-indicator padding
        if ('ResizeObserver' in window) {
          barRO = new ResizeObserver(function () { schedule(); });
          barRO.observe(barEl);
        }
      }
    }
    var h = barEl ? Math.round(barEl.getBoundingClientRect().height) : 0;
    root.style.setProperty('--nv-bar-h', h + 'px');
    // the bar already includes the safe-area padding, so don't add it twice
    root.style.setProperty('--nv-ex-b', h > 0 ? '0px' : 'env(safe-area-inset-bottom, 0px)');
    root.classList.toggle('nv-has-bar', h > 0);
    updateSticky();
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(measureBar, 60); }
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('load', measureBar);
  window.addEventListener('pageshow', schedule);
  if (mq.addEventListener) mq.addEventListener('change', schedule);

  /* ---------------------------------------------------------
     2. sticky add to cart
  --------------------------------------------------------- */
  var bar, titleEl, priceEl, go, info, kbd = false, ticking = false;

  function getForm() { return document.querySelector('product-info product-form, .product product-form, product-form'); }
  function getBtn() { var f = getForm(); return f ? f.querySelector('button[name="add"]') : null; }

  function readInfo() {
    var scope = document.querySelector('product-info') || document;
    var title = scope.querySelector('.product__title');
    var price = scope.querySelector('.price-item--last, .price__regular .price-item');
    return {
      title: title ? title.textContent.trim() : document.title,
      price: price ? price.textContent.trim() : ''
    };
  }

  function refresh() {
    if (!bar) return;
    var btn = getBtn();
    var i = readInfo();
    titleEl.textContent = i.title;
    priceEl.textContent = i.price;
    if (btn) {
      var label = btn.querySelector('span');
      go.textContent = label ? label.textContent.trim() : 'Add to cart';
      go.disabled = btn.disabled; // truly sold out / unavailable
      go.classList.toggle('is-busy', !btn.disabled && btn.getAttribute('aria-disabled') === 'true'); // adding...
    }
    updateSticky();
  }

  function blocked() {
    // keyboard open, or a drawer / popup / lightbox is open (Dawn sets overflow-hidden on <body>)
    if (kbd) return true;
    if (document.body.classList.contains('overflow-hidden')) return true;
    if (document.body.style.overflow === 'hidden') return true;
    var cd = document.querySelector('cart-drawer');
    if (cd && cd.classList.contains('active')) return true;
    return false;
  }

  function updateSticky() {
    ticking = false;
    if (!bar) return;
    var btn = getBtn();
    var show = false;
    if (btn && mq.matches) {
      var r = btn.getBoundingClientRect();
      // main button has fully scrolled off the TOP of the screen
      var passed = r.height > 0 && r.bottom < 0;
      var soldOut = btn.disabled;
      show = passed && !soldOut && !blocked();
    }
    bar.classList.toggle('is-on', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
    var h = show ? Math.round(bar.getBoundingClientRect().height) : 0;
    root.style.setProperty('--nv-atc-h', h + 'px');
    root.classList.toggle('nv-atc-on', show);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    raf(updateSticky);
  }

  function initSticky() {
    var form = getForm();
    if (!form || !getBtn()) return;

    bar = document.createElement('div');
    bar.className = 'nv-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.setAttribute('inert', '');
    bar.innerHTML =
      '<div class="nv-sticky-atc__info"><span class="nv-sticky-atc__title"></span><span class="nv-sticky-atc__price"></span></div>' +
      // data-add-to-cart lets the cart animation start from THIS button
      '<button type="button" class="nv-sticky-atc__btn" data-add-to-cart></button>';
    document.body.appendChild(bar);
    titleEl = bar.querySelector('.nv-sticky-atc__title');
    priceEl = bar.querySelector('.nv-sticky-atc__price');
    go = bar.querySelector('.nv-sticky-atc__btn');

    go.addEventListener('click', function () {
      var btn = getBtn(); // always the live button (it is re-rendered on variant change)
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var f = btn.form || btn.closest('form');
      // requestSubmit runs the normal submit handlers (variant, add-ons, animation)
      // without firing a second fake "click" on the hidden main button.
      if (f && f.requestSubmit) f.requestSubmit(btn); else btn.click();
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    // keyboard: never sit on top of the keyboard / input
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches('input:not([type=checkbox]):not([type=radio]):not([type=range]), textarea, select')) {
        kbd = true; updateSticky();
      }
    });
    document.addEventListener('focusout', function () {
      setTimeout(function () {
        var a = document.activeElement;
        kbd = !!(a && a.matches && a.matches('input:not([type=checkbox]):not([type=radio]):not([type=range]), textarea, select'));
        updateSticky();
      }, 120);
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        var vv = window.visualViewport;
        if (vv.height < window.innerHeight * 0.75) { kbd = true; } else if (!document.activeElement || !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) { kbd = false; }
        updateSticky();
      });
    }

    // drawers / popups toggling <body> classes or inline overflow
    new MutationObserver(requestUpdate).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    var cd = document.querySelector('cart-drawer');
    if (cd) new MutationObserver(requestUpdate).observe(cd, { attributes: true, attributeFilter: ['class'] });

    // variant change / price change / sold out: product-info re-renders its parts
    var scope = document.querySelector('product-info') || form.closest('section') || form;
    var rt;
    new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(refresh, 60); })
      .observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    refresh();
    measureBar();
  }

  function boot() { measureBar(); setTimeout(measureBar, 600); setTimeout(measureBar, 1800); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
